var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { Modal } from '@doordash/component-modal';
import styled from 'styled-components';
import { HowToPlaceOrderData } from '../QuizV2PageData';
import ListCell from '@doordash/component-list-cell';
import { Inset, Spacing, Text } from '@doordash/design-language';
import track from '../../../../utils/track';
import { QuizEvents } from '../../../../constants/events';
var ImgContainer = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  height: ", ";\n  max-width: 100%;\n"], ["\n  display: block;\n  height: ", ";\n  max-width: 100%;\n"])), function (props) { return props.height + "px"; });
export var HowToPlaceOderModal = function (_a) {
    var onClose = _a.onClose, navigateToOrder = _a.navigateToOrder;
    React.useEffect(function () {
        track(QuizEvents.GO_HOW_TO_PLACE_MODAL_OPEN);
    });
    return (React.createElement(Modal, { onClose: onClose, title: HowToPlaceOrderData.title, size: Modal.Sizes.XLarge, primaryAction: {
            text: HowToPlaceOrderData.primaryCta.text,
            onClick: navigateToOrder,
        }, secondaryAction: {
            text: HowToPlaceOrderData.secondaryCta.text,
            onClick: onClose,
        } }, HowToPlaceOrderData.steps.map(function (step, sIndex) { return (React.createElement(ListCell, { key: "step-" + sIndex, subtext: React.createElement(Text, { styles: Text.Styles.Body2, color: Text.Colors.TextSecondary }, step.text), isSeparatorVisible: false, insetHorizontalSize: ListCell.InsetSizes.XxSmall, insetVerticalSize: ListCell.InsetSizes.XxSmall, columnGapSize: Spacing.XxSmall, renderBeforeContent: function () { return (React.createElement(Text, { styles: Text.Styles.Body2, color: Text.Colors.TextSecondary }, sIndex + 1 + ".")); }, renderBelowContent: function () {
            return !!step.img && (React.createElement(Inset, { horizontalSize: Inset.Sizes.None, verticalSize: Inset.Sizes.XxSmall },
                React.createElement(ImgContainer, { src: step.img.src, alt: step.img.alt, height: step.img.height })));
        } })); })));
};
export default HowToPlaceOderModal;
var templateObject_1;
